/**
 * Branded splash shown while the Keycloak adapter initialises. Without it
 * the page is a blank dark void for the ~500ms before Keycloak either
 * 302s to the login form or resolves a cached session — and that void
 * is the first thing every consultant sees on every cold load.
 *
 * The splash is rendered directly into <body> on page bootstrap and
 * hidden via hideSplash() once auth resolves.
 */
export function showSplash(message = "Signing in"): void {
  if (document.getElementById("tfg-splash")) return;

  const el = document.createElement("div");
  el.id = "tfg-splash";
  el.className =
    "fixed inset-0 z-50 flex flex-col items-center justify-center bg-ink animate-[fadeIn_120ms_ease-out]";
  el.setAttribute("role", "status");
  el.setAttribute("aria-live", "polite");

  el.innerHTML = `
    <div class="flex flex-col items-center gap-6">
      <img src="/tfg-logo.svg" alt="Twenty First Group" class="h-12 w-auto" />
      <div class="flex items-center gap-3 text-sm text-bone-muted">
        <span class="relative flex h-2 w-2">
          <span class="absolute inline-flex h-full w-full rounded-full bg-tfg opacity-75 animate-ping"></span>
          <span class="relative inline-flex rounded-full h-2 w-2 bg-tfg"></span>
        </span>
        <span>${escapeForSplash(message)}…</span>
      </div>
    </div>
    <div class="absolute bottom-6 text-xs text-bone-muted/60 font-mono tracking-wider">
      PITCH
    </div>
  `;

  document.body.appendChild(el);
}

export function hideSplash(): void {
  const el = document.getElementById("tfg-splash");
  if (!el) return;
  // Fade out for 150ms before removing so the chrome doesn't pop in.
  el.style.transition = "opacity 150ms ease-out";
  el.style.opacity = "0";
  setTimeout(() => el.remove(), 160);
}

function escapeForSplash(s: string): string {
  return s.replace(/[&<>"']/g, (c) =>
    c === "&" ? "&amp;" : c === "<" ? "&lt;" : c === ">" ? "&gt;" : c === '"' ? "&quot;" : "&#39;",
  );
}
